export const RECEIVE_DATA = 'NETWORTHREPORT.RECEIVE_DATA';
export const SET_ERRORS = 'NETWORTHREPORT.SET_ERRORS';
export const SET_RANGE = 'NETWORTHREPORT.SET_RANGE';

export const RESET_STATE = 'NETWORTHREPORT.RESET_STATE';

export const receive_data = (resp_data, clientId) => ({
  type: RECEIVE_DATA,
  resp_data,
  clientId,
});

export const set_errors = (errors, clientId) => ({
  type: SET_ERRORS,
  errors,
  clientId,
});

export const set_range = (range, clientId) => ({
  type: SET_RANGE,
  range,
  clientId,
});

export const fetch_data = (pivot, clientId) => {
  if (!clientId) { return {}; }
  return (dispatch) => {
    ADV.util.request({
      uri: 'Consumer/NetWorth',
      data: {
        clientId,
        pivot,
      },
    }).then((resp) => {
      if (resp.success) {
        dispatch(receive_data(resp.payload.viewData, clientId));
      } else {
        dispatch(set_errors(resp.errors, clientId));
      }
    });
  };
};

export const resetState = () => ({
  type: RESET_STATE,
});
